var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fffbc5;}.cls-2{fill:#febe10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mood"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300,574.75A275,275,0,0,1,105.55,105.29,275,275,0,1,1,494.45,494.2,273.19,273.19,0,0,1,300,574.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300,49.75a250.08,250.08,0,0,1,97.3,480.37A250.08,250.08,0,0,1,202.7,69.37,248.46,248.46,0,0,1,300,49.75m0-50C134.31-.25,0,134.06,0,299.75s134.31,300,300,300,300-134.32,300-300S465.69-.25,300-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.89,465.11c-33.4,0-65.82-10.75-93.76-31.08a167.63,167.63,0,0,1-36.39-35.74,25,25,0,0,1,40.63-29.14c3.37,4.7,34.55,46,89.52,46,5.79,0,57.48-1.29,89.52-46A25,25,0,0,1,431,398.29c-19.47,27.14-47.1,47.22-79.9,58.08A167.81,167.81,0,0,1,300.89,465.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226,175.45c-22.8,0-40,24.79-40,57.65s17.2,57.65,40,57.65S266,266,266,233.1,248.8,175.45,226,175.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M374,175.45c-22.8,0-40,24.79-40,57.65s17.2,57.65,40,57.65S414,266,414,233.1,396.8,175.45,374,175.45Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMood);
export default __webpack_public_path__ + "static/media/mood.61d6f72566eb428b0ead23a5c1dec1ff.svg";
export { ForwardRef as ReactComponent };